import api from "@/lib/api";

// CREATE
export const createUnlistedFirm = async (payload) => {
  const res = await api.post("/unlisted-firms/create", payload);
  return res.data;
};

// GET ALL
export const getAllUnlistedFirms = async () => {
  const res = await api.get("/unlisted-firms/all");
  return res.data;
};

// GET BY ID
export const getUnlistedFirmById = async (id) => {
  const res = await api.get(`/unlisted-firms/${id}`);
  return res.data;
};

// DELETE
export const deleteUnlistedFirm = async (id) => {
  const res = await api.post(`/unlisted-firms/delete/${id}`);
  return res.data;
};

// UPDATE (when backend is ready)
export const updateUnlistedFirm = async (payload) => {
  const res = await api.post("/unlisted-firms/update", payload);
  return res.data;
};